<template>
  <ElCheckbox v-model="data.value" />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Widget } from '@/models'

/** 单选框填写 */
export default defineComponent({
  name: 'FaCheckboxFill',

  props: {
    /** 控件数据 */
    data: {
      type: Widget,
      required: true
    }
  }
})
</script>
